<template>
    <validation-observer ref="timeForm">
        <div>
            <div class="form-group p-0-14">
                <label class="attribute-label" :for="id">
                    {{ attribute.attribute_name }}
                    <a href="javascript:;" data-toggle="popover" data-placement="bottom" data-html="true" :data-content="popover_custom_data(attribute.extra_info)" v-if="removeTags(attribute.extra_info) !== ''"> <i class="fa fa-info-circle"></i></a>
                </label>
                <validation-provider :rules="attribute.mandatory ? 'required' : ''" v-slot="{errors}">
                    <div class="time-attribute input-group">
                        <input ref="time" :id="id" :name="name" class="form-control input-group-new-design"
                               placeholder="Time" v-model="time">
                        <span class="input-group-addon input-group-addon-new-design"><span
                            class="glyphicon glyphicon-time"></span></span>
                    </div>
                    <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
    </validation-observer>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import moment from "moment/moment";
export default {
    name: "TimeAttribute",
    props: {
        attribute: {
            type: Object,
            required: true
        },
        value: null,
        timeFormat: null,
        clone: 0
    }, components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            time: this.value,
            input: null
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }
            
            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }
            
            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        }
    },
    methods: {
        addEventListeners() {


            EventBus.$on('onServiceAttributesValidation', async (verify) => {
                let validated = await this.$refs.timeForm.validate();
                if(!validated)
                {
                    /** If there is a validation error then show the validation and open collapsed services  **/
                    EventBus.$emit('onCollapseService',this.attribute)

                }
                verify(validated)
            })

        },
        addTimePickerEventListener() {
            this.input.on('dp.change', (event) => {
                this.time = event.target.value
                this.$emit('input', event.target.value)
                EventBus.$emit('onCustomFieldUpdated', {
                    attribute: this.attribute,
                    value: event.target.value
                })
            })
        },
        initiateTimePicker() {
            this.$nextTick(() => {
                this.input = $(this.$refs['time']).datetimepicker({
                    format: this.timeFormat
                })
                this.addTimePickerEventListener();
            })
        },
        setValue(time) {
            this.time = time;
            if((this.input || {}).datetimepicker){
                this.input.datetimepicker('setTime', this.time)
            }
        },
        retrieveValue() {
            if (this.attribute.service_attribute_value) {
                return this.attribute.service_attribute_value
            } else if (this.value) {
                return this.value
            }
            return null
        },
        removeTags(value) {
            const div = document.createElement('div');
            div.innerHTML = value;
            var DataToAdd=null
            if(div.textContent){
                DataToAdd= div.textContent
            }
            else if(div.innerText){
                DataToAdd= div.innerText
            }else{   DataToAdd= '';  }
            if(DataToAdd){
                return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${DataToAdd}</div>`;
            }else {
                return DataToAdd;
            }
            },
        popover_custom_data(value) {
            return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${value}</div>`;;
        },
    },
    mounted() {
        this.addEventListeners()
        this.$nextTick(() => {
            this.initiateTimePicker();
            this.setValue(this.retrieveValue())
        })
    },
}
</script>

<style scoped>

</style>